import React from 'react';
import Sooprint from '../../components/SooPrint/Sooprint';

const SooPrintPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>수프린트</div>
            <hr  className=' ml-28 mr-28'/>
            <Sooprint/>            
        </div>
    );
};

export default SooPrintPage;